import { ErrorBoundary } from '@libs/templates/template-pages';
import { Route } from 'react-router-dom';
import { ContainerWithContext } from './layouts';

export const faRouter = (
  <Route path="/fa" element={<ContainerWithContext />} errorElement={<ErrorBoundary />}>
    <Route index path="/fa/main-menu" lazy={async () => import('./pages/MainMenu')} />
    <Route path="/fa/not-found" lazy={async () => import('./pages/NotFound')} />
    <Route path="/fa/segment-mst/:segmentMstKey/*" lazy={async () => import('./pages/SegmentMstIndex')} />
    <Route path="/fa/category-mst/*" lazy={async () => import('./pages/CategoryMstIndex')} />
    <Route path="/fa/la-start/*" lazy={async () => import('./pages/LaStartRegistrationIndex')} />
    <Route path="/fa/la-cancel-bef-maturity/*" lazy={async () => import('./pages/CancelBefMaturityIndex')} />
    <Route
      path="/fa/la-contract-info-change/*"
      lazy={async () => import('./pages/LaContractInfoChangeIndex')}
    />
    <Route
      path="/fa/la-article-info-change/*"
      lazy={async () => import('./pages/LaArticleInfoChangeIndex')}
    />
    <Route path="/fa/lease-company-mst/*" lazy={async () => import('./pages/LeaseCompanyMstIndex')} />
    <Route path="/fa/sub-category-mst/*" lazy={async () => import('./pages/SubCategoryMstIndex')} />
    <Route path="/fa/la-start-import" lazy={async () => import('././pages/LaStartImport')} />
    <Route path="/fa/la-migrate-balance-import" lazy={async () => import('./pages/LaMigrateBalanceImport')} />
    <Route path="/fa/la-migrate-balance-delete" lazy={async () => import('./pages/LaMigrateBalanceDelete')} />
    <Route
      path="/fa/la-contract-ledger-details"
      lazy={async () => import('./pages/LaContractLedgerDetails')}
    />
    <Route path="/fa/la-article-payment-list" lazy={async () => import('./pages/LaArticlePaymentList')} />
    <Route
      path="/fa/business-connection-mst/*"
      lazy={async () => import('./pages/BusinessConnectionMstIndex')}
    />
    <Route path="/fa/la-article-ledger-details" lazy={async () => import('./pages/LaArticleLedgerDetails')} />
    <Route path="/fa/location-mst/*" lazy={async () => import('./pages/LocationMstIndex')} />
    <Route
      path="/fa/fixed-asset-ledger-details"
      lazy={async () => import('./pages/FixedAssetLedgerDetails')}
    />
    <Route
      path="/fa/article-management-settings"
      lazy={async () => import('./pages/ArticleManagementSettings')}
    />
    <Route path="/fa/accounting-policy/*" lazy={async () => import('./pages/AccountingPolicyIndex')} />
    <Route
      path="/fa/la-cancel-registration"
      lazy={async () => import('./pages/LaCancelRegistrationSearch')}
    />
    <Route
      path="/fa/re-lease-and-contract-expired/*"
      lazy={async () => import('./pages/ReLeaseAndContractExpiredIndex')}
    />

    <Route path="/fa/job-watch/*" lazy={async () => import('./pages/JobWatchRegistration')} />
    <Route path="/fa/operation-control" lazy={async () => import('./pages/OperationControl')} />
    <Route
      path="/fa/confirm-settlement-status"
      lazy={async () => import('./pages/ClosingStateCheckRegistration')}
    />

    <Route path="/fa/mst-setting" lazy={async () => import('./pages/MstInfoSettings')} />
    <Route path="/fa/carry-over" lazy={async () => import('./pages/CarryOver')} />
    <Route
      path="/fa/reference-la-article-registration-history"
      lazy={async () => import('./pages/ReferenceLaArticleRegistrationHistorySearch')}
    />
    <Route
      path="/fa/reference-la-contract-registration-history"
      lazy={async () => import('./pages/ReferenceLaContractRegistrationHistorySearch')}
    />
    <Route path="/fa/fa-un-updated" lazy={async () => import('./pages/FaUnUpdated')} />
    <Route path="/fa/la-article-list-search" lazy={async () => import('./pages/LaArticleListSearch')} />
    <Route path="/fa/la-un-updated" lazy={async () => import('./pages/LaUnUpdated')} />
    <Route
      path="/fa/fixed-asset-depreciation-expenses-summary"
      lazy={async () => import('./pages/FixedAssetDepreciationExpensesSummary')}
    />
    <Route
      path="/fa/fixed-asset-impairment-statement"
      lazy={async () => import('./pages/FixedAssetImpairmentStatement')}
    />
    <Route path="/fa/lease-liability-ledger" lazy={async () => import('./pages/LeaseLiabilityLedger')} />
    <Route
      path="/fa/la-contract-payment-confirmation-form"
      lazy={async () => import('./pages/LaContractPaymentConfirmationFrom')}
    />
    <Route
      path="/fa/fixed-asset-impairment-loss-entry/*"
      lazy={async () => import('./pages/FixedAssetImpairmentLossEntryIndex')}
    />
    <Route
      path="/fa/fixed-asset-cancel-incre-decre"
      lazy={async () => import('./pages/FixedAssetCancelIncreDecre')}
    />
    <Route
      path="/fa/la-article-principal-repayment-schedule"
      lazy={async () => import('./pages/LaArticlePrincipalRepaymentSchedule')}
    />
    <Route path="/fa/interest-rate-setting/*" lazy={async () => import('./pages/InterestRateSetting')} />
    <Route
      path="/fa/lease-contract-list-reference"
      lazy={async () => import('./pages/LeaseContractListReference')}
    />
    <Route path="/fa/fixed-asset-list-inquiry" lazy={async () => import('./pages/FixedAssetListInquiry')} />
    <Route
      path="/fa/fixed-asset-incre-decre-total-table"
      lazy={async () => import('./pages/FixedAssetIncreDecreTotalTable')}
    />
    <Route
      path="/fa/lease-liability-estimate-change/*"
      lazy={async () => import('./pages/LeaseLiabilityEstimateChangeIndex')}
    />
  </Route>
);
